import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import LoadingScreen from "../../../components/LoadingScreen.js";
import { decryptData } from "src/utils/decryptcookie";
import DashboardLayout from "../../../layouts/dashboard/index.js";
import AuthGuard from "../../../guards/AuthGuard.js";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");
 

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard  && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            }),
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};



const EnquiryTable = Loadable(
  lazy(() => import("src/pages/EnquiryTable.js"))
);
const AdminDashboard = Loadable(
  lazy(() => import("src/pages/dashboard/Main/AdminDashboard.js"))
);
const CorporateList = Loadable(
  lazy(() =>
    import("src/components/_corporate/CorporateList/CorporateList.jsx")
  )
);
const DemoTable = Loadable(lazy(() => import("../../../pages/DemoTable.js")));

const FlightInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/FlightInvoice.js"))
);
const FlightInvoiceBreakdownPage = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/common/FlightInvoiceBreakdownPage.jsx"))
);
const HotelInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/HotelInvoice.js"))
);

const GeneralApp = Loadable(
  lazy(() => import("../../../pages/dashboard/GeneralApp.js"))
);
const GeneralEcommerce = Loadable(
  lazy(() => import("../../../pages/dashboard/GeneralEcommerce.js"))
);
const GeneralAnalytics = Loadable(
  lazy(() => import("../../../pages/dashboard/GeneralAnalytics.js"))
);
const GeneralBanking = Loadable(
  lazy(() => import("../../../pages/dashboard/GeneralBanking.js"))
);
const GeneralBooking = Loadable(
  lazy(() => import("../../../pages/dashboard/GeneralBooking.js"))
);
const EcommerceShop = Loadable(
  lazy(() => import("../../../pages/dashboard/EcommerceShop.js"))
);
const EcommerceProductDetails = Loadable(
  lazy(() => import("../../../pages/dashboard/EcommerceProductDetails.js"))
);
const EcommerceProductList = Loadable(
  lazy(() => import("../../../pages/dashboard/EcommerceProductList.js"))
);
const EcommerceProductCreate = Loadable(
  lazy(() => import("../../../pages/dashboard/EcommerceProductCreate.js"))
);
const EcommerceCheckout = Loadable(
  lazy(() => import("../../../pages/dashboard/EcommerceCheckout.js"))
);
const EcommerceInvoice = Loadable(
  lazy(() => import("../../../pages/dashboard/EcommerceInvoice.js"))
);
const Resultoneway = Loadable(
  lazy(() => import("../../../pages/dashboard/resultoneway.js"))
);
const Resulttwoway = Loadable(
  lazy(() => import("../../../pages/dashboard/resulttwoway.js"))
);

// const Travellersinfo = Loadable(
//   lazy(() => import("../../pages/dashboard/TravellersInfo"))
// );
const AgentToCheckRules = Loadable(
  lazy(() =>
    import(
      "../../../components/_dashboard/adminPages/AdminFareRuleChooseAgent.js"
    )
  )
);
const BulkData = Loadable(
  lazy(() => import("../../../pages/ScrappingManegment/Bulkdata.js"))
);
const ScrappyUser = Loadable(
  lazy(() => import("../../../pages/ScrappingManegment/AddScrappyUser.js"))
);
const ViewScrappyUser = Loadable(
  lazy(() => import("../../../pages/ScrappingManegment/ViewScappyUser.js"))
);
const GetMeta = Loadable(lazy(() => import("../../../pages/Meta-mange.js")));
const AppliedRule = Loadable(
  lazy(() => import("../../../pages/FareRule/ExistingFareRule.js"))
);
const ViewAllData = Loadable(
  lazy(() => import("../../../pages/ScrappingManegment/ViewData.js"))
);
const AddIternary = Loadable(
  lazy(() => import("../../../pages/ScrappingManegment/AddIternary.js"))
);
const Approval = Loadable(
  lazy(() => import("../../../pages/PaymentRequests/approval.js"))
);
const AllRequest = Loadable(
  lazy(() => import("../../../pages/PaymentRequests/AllRequest.js"))
);
const ChooseAgent = Loadable(
  lazy(() => import("../../../pages/AccountTranscation/ChooseAgent.js"))
);
const AgentLedger = Loadable(
  lazy(() => import("../../../pages/AccountTranscation/AgentLedger.js"))
);
// const CreateBooking = Loadable(lazy(() => import("../../pages/BookingApi")));
const Cancellations = Loadable(
  lazy(() => import("../../../pages/cancellations.js"))
);
const BlogPosts = Loadable(
  lazy(() => import("../../../pages/dashboard/BlogPosts.js"))
);
const BlogPost = Loadable(
  lazy(() => import("../../../pages/dashboard/BlogPost.js"))
);
//Harsh
const AgentInfoTable = Loadable(
  lazy(() =>
    import("src/pages/RelationshipManager/AgentSection/AgentInfoTable.js")
  )
);
const AgentListPage = Loadable(
  lazy(() =>
    import("src/pages/RelationshipManager/AgentSection/AgentListPage.jsx")
  )
);
const AddAgents = Loadable(
  lazy(() =>
    import("../../../pages/RelationshipManager/AgentSection/AddAgents.js")
  )
);
const AddCorporate = Loadable(
  lazy(() =>
    import("src/pages/RelationshipManager/CorporateSection/AddCorporate.js")
  )
);
const EditAgentInfoPage = Loadable(
  lazy(() =>
    import("../../../pages/RelationshipManager/AgentSection/EditAgentInfoPage.jsx")
  )
);
const ViewAgentInfo = Loadable(
  lazy(() =>
    import("../../../pages/RelationshipManager/AgentSection/ViewAgentInfo.js")
  )
);
const AgentWallet = Loadable(
  lazy(() =>
    import("../../../pages/RelationshipManager/AgentSection/AgentWallet.js")
  )
);
const TwoWayTravellersInfo = Loadable(
  lazy(() => import("../../../pages/dashboard/TwoWayTravellersInfo.js"))
);
const ManagerTable = Loadable(
  lazy(() => import("../../../pages/Manager/ManagerTable.js"))
);
const AddManager = Loadable(
  lazy(() => import("../../../pages/Manager/AddManager.js"))
);
const EditManagerInfo = Loadable(
  lazy(() => import("../../../pages/Manager/editManagerInfo.js"))
);
const ManagerProfilePage = Loadable(
  lazy(() => import("../../../pages/Manager/ManagerProfilePage.js"))
);
const LoginActivityTracker = Loadable(
  lazy(() => import("src/pages/LoginActivity/LoginActivityTracker.jsx"))
);
const LoginReport = Loadable(
  lazy(() => import("src/pages/LoginActivity/LoginReport.jsx"))
);
const FlightAgentSelect = Loadable(
  lazy(() => import("src/pages/FlightAgentSelect/FlightAgentSelect.jsx"))
);
const UserListing = Loadable(
  lazy(() => import("src/pages/UserListing/UserListing.jsx"))
);
const SubAgentTable = Loadable(
  lazy(() => import("../../../pages/AgentPortal/SubAgentTable.js"))
);
const AddAgentInfo = Loadable(
  lazy(() => import("../../../pages/AgentPortal/AddSubAgent.js"))
);
const EditSubAgent = Loadable(
  lazy(() => import("../../../pages/AgentPortal/EditSubAgent.js"))
);
const SubAgentProfile = Loadable(
  lazy(() => import("../../../pages/AgentPortal/SubAgentProfile.js"))
);
const SubAgentList = Loadable(
  lazy(() => import("src/pages/AgentPortal/table/SubAgentList.js"))
);
const SubAgentWallet = Loadable(
  lazy(() => import("../../../pages/AgentPortal/SubAgentWallet.js"))
);
const OTPVerification = Loadable(
  lazy(() => import("../../../pages/authentication/OTPVerification.js"))
);
const AddAccountant = Loadable(
  lazy(() => import("../../../pages/AccountsDepartment/AddAccountant.js"))
);
const TransactionPage = Loadable(
  lazy(() => import("../../../pages/AccountsDepartment/TransactionPage.js"))
);
const AccountantTable = Loadable(
  lazy(() => import("../../../pages/AccountsDepartment/AccountantTable.js"))
);
const BookingTablePage = Loadable(
  lazy(() => import("../../../pages/Bookings/BookingTablePage.js"))
);
const HotelBookingTablePage = Loadable(
  lazy(() => import("../../../pages/hotels/menu/HotelBookingTablePage.js"))
);
const BookingTablePageTransfers = Loadable(
  lazy(() => import("../../../pages/Transfer/BookingTablePageTransfers.js"))
);
const InhouseAgentTable = Loadable(
  lazy(() => import("../../../pages/InhouseAgents/InhouseAgentTable.js"))
);
const AddInhouseAgents = Loadable(
  lazy(() => import("../../../pages/InhouseAgents/AddInhouseAgents.js"))
);
const EditBookingDetails = Loadable(
  lazy(() => import("../../../pages/InhouseAgents/EditBookingDetails.js"))
);
const AmendmentPage = Loadable(
  lazy(() => import("../../../pages/AgentPortal/AmendmentPage.js"))
);
const Amendments = Loadable(
  lazy(() => import("../../../pages/InhouseAgents/Amendments.js"))
);
const AmendmentsHotels = Loadable(
  lazy(() => import("../../../pages/hotels/menu/AmendmentsHotels.js"))
);
const AmendmentsTransfers = Loadable(
  lazy(() => import("../../../pages/Transfer/AmendmentsTransfers.js"))
);
//Harsh

const BlogNewPost = Loadable(
  lazy(() => import("../../../pages/dashboard/BlogNewPost.js"))
);
const UserProfile = Loadable(
  lazy(() => import("../../../pages/dashboard/UserProfile.js"))
);
const UserCards = Loadable(
  lazy(() => import("../../../pages/dashboard/UserCards.js"))
);
const UserList = Loadable(
  lazy(() => import("../../../pages/dashboard/UserList.js"))
);
const UserAccount = Loadable(
  lazy(() => import("../../../pages/dashboard/UserAccount.js"))
);
const UserCreate = Loadable(
  lazy(() => import("../../../pages/dashboard/UserCreate.js"))
);
const Chat = Loadable(lazy(() => import("../../../pages/dashboard/Chat.js")));
const Mail = Loadable(lazy(() => import("../../../pages/dashboard/Mail.js")));
const Calendar = Loadable(
  lazy(() => import("../../../pages/dashboard/Calendar.js"))
);
const Kanban = Loadable(
  lazy(() => import("../../../pages/dashboard/Kanban.js"))
);
// Main
const FlightBooking = Loadable(
  lazy(() => import("../../../pages/Flightbooking.js"))
);
const HotelBooking = Loadable(
  lazy(() => import("../../../pages/hotels/menu/HotelBookingPage.js"))
);
const HotelListing = Loadable(
  lazy(() => import("../../../pages/hotels/HotelListing.js"))
);

const TransferMain = Loadable(
  lazy(() => import("../../../pages/Transfer/TransferMain.js"))
);

const PrivacyPolicy = Loadable(
  lazy(() => import("../../../pages/AbboutUs/privacyPolicy.js"))
);
const TermsAndConditons = Loadable(
  lazy(() => import("../../../pages/AbboutUs/Terms&Conditions.js"))
);

const Topup = Loadable(
  lazy(() => import("../../../components/_dashboard/Transaction/TopUp.js"))
);
const FareRule = Loadable(
  lazy(() => import("../../../components/_dashboard/adminPages/FareRule.js"))
);
const ApplyRule = Loadable(
  lazy(() => import("../../../pages/FareRule/ApplyRule.js"))
);
const Alltransaction = Loadable(
  lazy(() => import("../../../pages/PaymentRequests/AgentTransactions.js"))
);
const Transaction = Loadable(
  lazy(() => import("../../../pages/AccountTranscation/Transaction.js"))
);
const BookingsHistory = Loadable(
  lazy(() => import("../../../pages/Bookings/userBookings.js"))
);
// Components

// tables 
const ManagerTrackingPage = Loadable(
  lazy(() => import("src/pages/dashboard/ManagerTrackingTable/ManagerTrackingPage.js"))
);


export const AdminRoutes = () => {
  const parsedData = decryptData("_b60-g6fr_plus");

  return {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
       </AuthGuard>
    ),

    children: [
      {
        path: "",
        element: (
          <Navigate
            to={
              parsedData === null
                ? "/dashboard"
                : parsedData?.role === "admin"
                ? "/dashboard/manager-info"
                : parsedData?.role === "manager"
                ? "/dashboard/add-info"
                : parsedData?.role === "agent"
                ? "/dashboard/sub-agent-info"
                : parsedData?.role === "sub-agent"
                ? "/dashboard/bookingsHistory"
                : "/dashboard"
            }
            replace
          />
        ),
      },

      { path: "app", element: <GeneralApp /> },
      { path: "main", element: <AdminDashboard /> },
      { path: "user-profile", element: <UserProfile /> },
      { path: "sub-agent-info/:id", element: <SubAgentList /> },
      // { path: "sub-agent-profile", element: <SubAgentProfile /> },
      // Tables 
     { path : "table/manager-tracking", element : <ManagerTrackingPage />},
      { path: "ecommerce", element: <GeneralEcommerce /> },
      { path: "banking", element: <GeneralBanking /> },
      { path: "booking", element: <GeneralBooking /> },
      {
        path: "analytics",
        element: <GeneralAnalytics />,
      },
      // {path : }
      { path: "flight_booking", element: <FlightBooking /> },
      { path: "hotel_booking", element: <HotelBooking /> },
      { path: "hotelResult", element: <HotelListing /> },
      { path: "invoice_flight", element: <FlightInvoice /> },
      { path: "flight-invoice-breakdown", element: <FlightInvoiceBreakdownPage /> },
      { path: "invoice_hotel", element: <HotelInvoice /> },
      { path: "transfer_booking", element: <TransferMain /> },
      { path: "privacyPolicy", element: <PrivacyPolicy /> },
      { path: "termsAndConditions", element: <TermsAndConditons /> },
      { path: "resultoneway", element: <Resultoneway /> },
      { path: "resulttwoway", element: <Resulttwoway /> },
      { path: "farerule", element: <FareRule /> },
      { path: "applyrule", element: <ApplyRule /> },
      { path: "trans", element: <Transaction /> },
      { path: "topup", element: <Topup /> },
      { path: "AppliedRule", element: <AppliedRule /> },
      { path: "bookingsHistory", element: <BookingsHistory /> },
      { path: "approval", element: <Approval /> },
      { path: "alltransaction", element: <Alltransaction /> },
      { path: "chooseAgent", element: <ChooseAgent /> },
      { path: "agentLedger", element: <AgentLedger /> },
      { path: "cancellations", element: <Cancellations /> },
      { path: "checkAgentRules", element: <AgentToCheckRules /> },
      { path: "scrap-all-data", element: <ViewAllData /> },
      { path: "add-Iternary", element: <AddIternary /> },
      { path: "add-bulk-data", element: <BulkData /> },
      { path: "add-scrappy-user", element: <ScrappyUser /> },
      { path: "view-scrappy-user", element: <ViewScrappyUser /> },
      { path: "get-meta", element: <GetMeta /> },
      // { path: "add-info", element: <AgentInfoTable /> },
      { path: "add-info", element: <AgentListPage /> },
      { path: "add-agent-info", element: <AddAgents /> },
      { path: "add-corporate", element: <AddCorporate /> },
      { path: "edit-agent-info", element: <EditAgentInfoPage /> },
      { path: "agent-info", element: <ViewAgentInfo /> },
      { path: "agent-wallet", element: <AgentWallet /> },
      { path: "manager-info", element: <ManagerTable /> },
      { path: "all-requests", element: <AllRequest /> },
      { path: "edit-manager-info", element: <EditManagerInfo /> },
      { path: "sub-agent-info", element: <SubAgentTable /> },
      { path: "add-sub-agent-info", element: <AddAgentInfo /> },
      { path: "edit-sub-agent-info", element: <EditSubAgent /> },
      { path: "sub-agent-profile", element: <SubAgentProfile /> },
      { path: "sub-agent-wallet", element: <SubAgentWallet /> },
      { path: "add-accountant", element: <AddAccountant /> },
      { path: "accounts-all-requests", element: <TransactionPage /> },
      { path: "accounts-department-info", element: <AccountantTable /> },
      { path: "all-booking-details", element: <BookingTablePage /> },
      {
        path: "all-booking-details-hotels",
        element: <HotelBookingTablePage />,
      },
      {
        path: "all-booking-details-transfers",
        element: <BookingTablePageTransfers />,
      },
      { path: "show-inhouse-agents", element: <InhouseAgentTable /> },
      { path: "add-inhouseAgents", element: <AddInhouseAgents /> },
      { path: "get-all-amendments", element: <Amendments /> },
      {
        path: "get-all-amendments-hotels",
        element: <AmendmentsHotels />,
      },
      {
        path: "get-all-amendments-transfers",
        element: <AmendmentsTransfers />,
      },
      { path: "enquiry-table", element: <EnquiryTable /> },
      { path: "demo-table", element: <DemoTable /> },
      {
        path: "add-manager-info",
        element: <AddManager />,
      },
      {
        path: "manager-profile",
        element: <ManagerProfilePage />,
      },
      { path: "login-activity", element: <LoginActivityTracker /> },
      { path: "login-report", element: <LoginReport /> },
      { path: "flight-agent-select", element: <FlightAgentSelect /> },
      { path: "user-listing", element: <UserListing /> },

      // { path: "edit-booking-details", element: <EditBookingDetails /> },
      // @partners
      { path: "add-info", element: <AgentInfoTable /> },
      { path: "corporate-info", element: <CorporateList /> },
      {
        path: "e-commerce",
        children: [
          {
            path: "",
            element: <Navigate to="/dashboard/e-commerce/shop" replace />,
          },
          { path: "shop", element: <EcommerceShop /> },
          { path: "product/:name", element: <EcommerceProductDetails /> },
          { path: "list", element: <EcommerceProductList /> },
          { path: "product/new", element: <EcommerceProductCreate /> },
          {
            path: "product/:name/edit",
            element: <EcommerceProductCreate />,
          },
          { path: "checkout", element: <EcommerceCheckout /> },
          { path: "invoice", element: <EcommerceInvoice /> },
        ],
      },
      {
        path: "user",
        children: [
          {
            path: "",
            element: <Navigate to="/dashboard/user/profile" replace />,
          },
          { path: "profile", element: <UserProfile /> },
          { path: "cards", element: <UserCards /> },
          { path: "list", element: <UserList /> },
          { path: "new", element: <UserCreate /> },
          { path: "product/:name/edit", element: <UserCreate /> },
          { path: "account", element: <UserAccount /> },
        ],
      },
      {
        path: "blog",
        children: [
          {
            path: "",
            element: <Navigate to="/dashboard/blog/posts" replace />,
          },
          { path: "posts", element: <BlogPosts /> },
          { path: "post/:title", element: <BlogPost /> },
          { path: "new-post", element: <BlogNewPost /> },
        ],
      },
      {
        path: "mail",
        children: [
          {
            path: "",
            element: <Navigate to="/dashboard/mail/all" replace />,
          },
          { path: "label/:customLabel", element: <Mail /> },
          { path: "label/:customLabel/:mailId", element: <Mail /> },
          { path: ":systemLabel", element: <Mail /> },
          { path: ":systemLabel/:mailId", element: <Mail /> },
        ],
      },
      {
        path: "chat",
        children: [
          { path: "", element: <Chat /> },
          { path: "new", element: <Chat /> },
          { path: ":conversationKey", element: <Chat /> },
        ],
      },
      { path: "calendar", element: <Calendar /> },
      { path: "kanban", element: <Kanban /> },
    ],
  };
};
